// utils/scrollToFirstError.js
export const scrollToFirstError = (errors) => {
  const errorKeys = Object.keys(errors);
  if (!errorKeys.length) return;

  const anchors = Array.from(document.querySelectorAll('[data-error-anchor]')).filter((el) => {
    const name = el.getAttribute('data-error-anchor');
    if (!errorKeys.includes(name)) return false;

    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    const rect = el.getBoundingClientRect();
    if (rect.width === 0 && rect.height === 0) return false;
    return true;
  });

  const first = anchors[0];
  if (!first) return;

  first.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const container =
    first.closest('[data-form-item]') || first.parentElement;

  const focusable =
    container?.querySelector(
      'input,textarea,select,button,[role="button"],[tabindex]'
    ) || container;

  focusable?.focus?.({ preventScroll: true });
};
